/**
 * FELVORA — ago-2026 · CATÁLOGO DE REGÍMENES leído del backend.
 *
 * Ni la landing ni el wizard de registro vuelven a escribir a mano la lista de regímenes.
 * `GET /api/meta` (público) entrega `regimenes` con `{id, nombre, activo, autoridad, grupo,
 * fraccion}`. Habilitar una fracción nueva desde el catálogo del backend la publica sola en
 * las dos pantallas, sin desplegar frontend.
 *
 * Grupos: `financiera` (CNBV/CONDUSEF) · `actividad_vulnerable` (Art. 17 LFPIORPI) ·
 * `legacy_oculto` (entradas históricas del catálogo que no se muestran nunca).
 */
import { api } from "@/lib/api";

// Ícono de lucide-react por fracción del Art. 17. Solo presentación: si una fracción nueva
// no está aquí, cae a un ícono neutro y la tarjeta se pinta igual.
export const ICONO_POR_FRACCION = {
  I: "Ticket", II: "CreditCard", III: "Plane", IV: "HandCoins",
  V: "Building", "V Bis": "Building2", VI: "Gem", VII: "Palette",
  VIII: "Car", IX: "ShieldCheck", X: "Truck", XI: "Briefcase",
  XII: "Stamp", XIII: "Gift", XIV: "Ship", XV: "KeyRound", XVI: "Bitcoin",
};

export const ICONO_POR_REGIMEN_FINANCIERO = {
  sofom_enr: "Wallet", centro_cambiario: "ArrowLeftRight",
  transmisor_dinero: "Send", ifpe: "Smartphone", ifc: "Building2",
};

const ORDEN_FRACCION = [
  "I", "II", "III", "IV", "V", "V Bis", "VI", "VII", "VIII", "IX", "X",
  "XI", "XII", "XIII", "XIV", "XV", "XVI",
];

/** Descarga el catálogo y lo separa en los dos grupos que se muestran al público. */
export async function cargarRegimenes() {
  const { data } = await api.get("/meta");
  const todos = (data?.regimenes || []).filter((r) => r.grupo !== "legacy_oculto");
  const financieras = todos
    .filter((r) => r.grupo === "financiera")
    .map((r) => ({ ...r, icono: ICONO_POR_REGIMEN_FINANCIERO[r.id] || "Landmark" }));
  const vulnerables = todos
    .filter((r) => r.grupo === "actividad_vulnerable")
    .map((r) => ({ ...r, icono: ICONO_POR_FRACCION[r.fraccion] || "ShieldAlert" }))
    .sort((a, b) => ORDEN_FRACCION.indexOf(a.fraccion) - ORDEN_FRACCION.indexOf(b.fraccion));
  return { financieras, vulnerables, todos };
}

/** Busca un régimen por id o por nombre (case-insensitive). Null si no existe. */
export function buscarRegimen(lista, valor) {
  const q = String(valor || "").trim().toLowerCase();
  if (!q) return null;
  return lista.find((r) => r.id.toLowerCase() === q || r.nombre.toLowerCase() === q) || null;
}
